import { Container } from "react-bootstrap"

const Blog = () => {

    return (
        <Container>
            <div className="b-example-divider"></div>
            <h1 className="text-center">Business Solutions</h1>
            <p>Due to some technical difficulty This page is unable to show content</p>
            
        </Container>
    );
}

export default Blog;